import { Typography } from '@mui/material'
import { withStyles } from '@mui/styles'

export const BoldTypography = withStyles(theme => ({
    root: {
        'font-weight': theme.typography.fontWeightMedium,
    },
}))(Typography)
